export const COLORS = { primary: '#2563eb' };

/** Prav Solutions marketing site (drawer logo link). */
export const PRAV_SOLUTIONS_HOME_URL =
  import.meta.env.VITE_PRAV_SOLUTIONS_HOME_URL?.trim() || 'https://www.pravsolutions.com';

/** PRAV Solutions social profiles (landing footer). */
export const SOCIAL_LINKS = {
  linkedIn: 'https://www.linkedin.com/company/pravsolutions/',
  facebook: 'https://www.facebook.com/pravsolutions',
  instagram: 'https://www.instagram.com/pravsolutions',
} as const;

/** Placeholder — not stored; user must pick a real category. */
export const CATEGORY_PLACEHOLDER_OPTION = 'Select';

/** Last option opens a custom category field on Create Bid. */
export const CATEGORY_CUSTOM_OPTION = 'Others';

/** Preset categories (excludes placeholder and custom option). */
export const CATEGORIES = [
  'Electrical',
  'Electronics',
  'Capital goods',
  'Raw material',
  'Machinery',
  'Services',
  'Furniture',
  'Construction',
  CATEGORY_CUSTOM_OPTION,
];

export const BID_CATEGORY_DROPDOWN_OPTIONS = [CATEGORY_PLACEHOLDER_OPTION, ...CATEGORIES];

export const DEFAULT_CATEGORY = CATEGORY_PLACEHOLDER_OPTION;

export const CURRENCIES = [
  { code: 'INR', symbol: '₹' },
  { code: 'USD', symbol: '$' },
  { code: 'CAD', symbol: 'C$' },
  { code: 'Euro', symbol: '€' },
  { code: 'GBP', symbol: '£' },
  { code: 'DHS', symbol: 'AED' },
];

export const DECREMENTAL_OPTIONS = [0.25, 0.5, 0.75, 1.0];
export const BID_DURATIONS = [30, 60];

/** Dev-only fallbacks when env files are missing; production builds must set VITE_* in `.env.production.local`. */
const defaultApi =
  import.meta.env.VITE_API_BASE_URL ||
  'https://bidmaster-api-dev-379922156590.asia-south2.run.app';
const defaultWs =
  import.meta.env.VITE_WS_URL ||
  'wss://bidmaster-api-dev-379922156590.asia-south2.run.app';

export const API_CONFIG = {
  BASE_URL: defaultApi.replace(/\/$/, ''),
  WS_URL: defaultWs.replace(/\/$/, ''),
  TIMEOUT: 10000,
};

/** Reserved for links shared outside the SPA. In-app terms live at /terms (see legalRoutes). */
export const APP_CONFIG = {
  TERMS_AND_CONDITIONS_URL: import.meta.env.VITE_TERMS_URL || 'https://yoursite.com/terms',
};

/** PRAV Solutions hosted checkout (PayU). Override per env if needed. */
const pravCheckoutBase =
  import.meta.env.VITE_PRAV_CHECKOUT_BASE_URL?.trim() ||
  'https://www.pravsolutions.com/bidmaster/subscribe';

export const CHECKOUT_CONFIG = {
  pravSubscribeBaseUrl: pravCheckoutBase.replace(/\/$/, ''),
  pravSubscribeHost: (() => {
    try {
      return new URL(pravCheckoutBase).hostname;
    } catch {
      return 'www.pravsolutions.com';
    }
  })(),
};

export const NO_VALID_SUBSCRIPTION_MESSAGE =
  'You do not have valid subscription, Please visit our website.';

export const SUBSCRIPTION_EXPIRED_MESSAGE =
  'Your subscription has expired. Please visit our website to renew your plan.';

/**
 * Play / App Store URLs for landing hero buttons.
 * TEMPORARY: StoreDownloadButtons currently shows "Coming Soon." instead of these links
 * until mobile apps are live — restore anchor tags there when publishing to stores.
 */
export const STORE_LINKS = {
  playStore:
    import.meta.env.VITE_PLAY_STORE_URL ||
    'https://play.google.com/store/apps/details?id=com.pravsolutions.bidmaster',
  appStore:
    import.meta.env.VITE_APP_STORE_URL || 'https://apps.apple.com/search?term=BidMaster',
};
